<template>
    <div v-if="activity.providerName != 0" class="card">
        <a :href="activity.nodeURL" class="card__link d-flex">
            <div v-lazy:background-image="backgroundImage"
                 :class="getTheme() + '__icon'"
                 class="card__background">
            </div>
            <div class="card__content d-flex flex-column align-self-stretch flex-grow-1 wave"
                 :class="getTheme() + '__wave'">
                <h2 :class="'color--' + getTheme()" class="mb-2">
                    {{ activity.title }}
                </h2>
                <ul class="col">
                    <li>
                        <i v-if="activity.providerName != null"
                           :class="'fa fa-address-book' + ' color--' + getTheme()"
                           aria-hidden="true">
                        </i><strong>{{ activity.providerName }}</strong>
                    </li>

                    <li v-if="
              activity.location != null &&
                activity.location[0] != null &&
                activity.location[0].name != null
            ">
                        <i :class="'fa fa-map-marker-alt' + ' color--' + getTheme()"
                           aria-hidden="true">
                        </i>{{ activity.location[0].fullAddress }}
                    </li>

                    <li>
                        <i :class="'fas fa-euro-sign mr-1' + ' color--' + getTheme()">
                        </i> <span v-if="
                activity.costType == 1 ||
                  activity.costType == 2 ||
                  activity.costType == 3
              ">
                            <span v-if="activity.costType == 1">{{ activity.costs }} per groep</span>
                            <span v-if="activity.costType == 2">{{ activity.costs }} per kind</span>
                            <span v-if="activity.costType == 3">Gratis</span>
                        </span>
                        <span v-else>{{ activity.costs }}</span>
                    </li>

                    <li>
                        <i :class="'fa fa-check' + ' color--' + getTheme()"
                           aria-hidden="true">
                        </i>{{ activity.lessonType }}
                    </li>

                </ul>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            schoolTimes: '',
            backgroundImage: '',
            showbutton: ''
        };
    },
    watch: {
        activity: function () { }
    },
    created() {
        if (
            this.activity.schoolTimes != null &&
            this.activity.schoolTimes[0] != null
        ) {
            if (this.activity.schoolTimes.length > 1) {
                this.schoolTimes = 'binnen en buiten schooltijd';
            } else {
                this.schoolTimes = this.activity.schoolTimes[0].name.toLowerCase();
            }
        }
        window.addEventListener('resize', this.setBackgroundImageOnResize);
        this.setBackgroundImageSize();
    },
    destroyed() {
        window.removeEventListener('resize', this.setBackgroundImageOnResize);
    },
    methods: {
        setBackgroundImageOnResize() {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setBackgroundImageSize();
            }, 300);
        },
        setBackgroundImageSize() {
            if (this.activity.headerImage !== null) {
                let background = this.activity.headerImage;
                if (this.$useWebP) {
                    if (background.includes('?')) {
                        background += '&format=webp';
                        if (!background.includes('width=')) {
                            background += '&width=350';
                        }
                    } else {
                        background += '?format=webp&width=350';
                    }
                }
                this.backgroundImage = background;
            }
        },
        getTheme() {
            return this.activity.theme != null && this.activity.theme[0] != null
                ? this.activity.theme[0].className
                : '';
        },
        getTargetAudience() {
            return this.activity.targetAudience != null &&
                this.activity.targetAudience[0] != null
                ? this.activity.targetAudience[0].className
                : '';
        }
    }
};
</script>

<style lang="scss" scoped>
    .card {
        flex: 1 1 auto;
        position: relative;
        padding: 0 35px 30px 35px;

        @include media-breakpoint-up(md) {
            padding: 0 15px;
        }

        &:hover {
            .card__background::after {
                bottom: 0;
            }
        }
    }

    .card a {
        text-decoration: none;
        background-color: $white;
        display: block;
        border-radius: 7px;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);
        overflow: hidden;

        &:hover {
            box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2);
        }
    }

    .card h2 {
        font-size: 1.125rem;
    }

    .ribbon {
        position: absolute;
        background: #fafafa;
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 12px 20px;
        opacity: 0.95;
        top: 20px;
    }

    .card__background {
        background-repeat: no-repeat;
        background-size: cover;
        top: 0;
        position: relative;
        bottom: 0;
        left: 0;
        right: 0;
        height: 130px;

        @media (min-height: 800px) {
            height: 140px;
        }

        @media (min-height: 900px) {
            height: 150px;
        }

        @media (min-height: 1080px) {
            height: 165px;
        }

        @media (min-height: 1200px) {
            height: 215px;
        }

        &.science__icon {
            &:after {
                background-image: url(/Content/img/icons/science.svg);
            }
        }

        &.nature__icon {
            &:after {
                background-image: url(/Content/img/icons/bloem.svg);
            }
        }

        &.history__icon {
            &:after {
                background-image: url(/Content/img/icons/pilaar.svg);
            }
        }

        &.technology__icon {
            &:after {
                background-image: url(/Content/img/icons/robot.svg);
            }
        }

        &.culture__icon {
            &:after {
                background-image: url(/Content/img/icons/masker.svg);
            }
        }

        &.expedition__icon {
            &:after {
                background-image: url(/Content/img/icons/vergrootglas.svg);
            }
        }

        &.dance__icon {
            &:after {
                background-image: url(/Content/img/icons/breakdancer.svg);
            }
        }

        &.music__icon {
            &:after {
                background-image: url(/Content/img/icons/microfoon.svg);
            }
        }

        &.art__icon {
            &:after {
                background-image: url(/Content/img/icons/verfborstel.svg);
            }
        }

        &.literature__icon {
            &:after {
                background-image: url(/Content/img/icons/boek.svg);
            }
        }

        &.media__icon {
            &:after {
                background-image: url(/Content/img/icons/laptop.svg);
            }
        }

        &.stage__icon {
            &:after {
                background-image: url(/Content/img/icons/stoel.svg);
            }
        }

        &:after {
            content: '';
            display: block;
            position: absolute;
            bottom: -70px;
            width: 70px;
            right: 20px;
            height: 70px;
            transition: bottom 0.25s ease-in-out 0s;
            background-size: contain;
            background-position: top;
            background-repeat: no-repeat;
            background-image: url(/Content/img/icons/molen.svg);
        }
    }

    .card__content {
        padding: 20px;
        color: $black;
        position: relative;

        &.wave::before {
            display: inline-block;
            content: '';
            -webkit-mask: url(/Content/img/card-waves/waves.svg) no-repeat 50% 50%;
            mask: url(/Content/img/card-waves/waves.svg) no-repeat 50% 50%;
            -webkit-mask-size: cover;
            mask-size: cover;
            top: -10px;
        }

        &.science__wave {
            &:before {
                background-color: #0057a5;
            }
        }

        &.nature__wave {
            &:before {
                background-color: #37a032;
            }
        }

        &.history__wave {
            &:before {
                background-color: #ea5a0b;
            }
        }

        &.technology__wave {
            &:before {
                background-color: #f59c00;
            }
        }

        &.culture__wave {
            &:before {
                background-color: #d12b18;
            }
        }

        &.expedition__wave {
            &:before {
                background-color: #747473;
            }
        }

        &.dance__wave {
            &:before {
                background-color: #00a0dd;
            }
        }

        &.music__wave {
            &:before {
                background-color: #9b878b;
            }
        }

        &.art__wave {
            &:before {
                background-color: #f59c00;
            }
        }

        &.literature__wave {
            &:before {
                background-color: #c8af8f;
            }
        }

        &.media__wave {
            &:before {
                background-color: #95c11e;
            }
        }

        &.stage__wave {
            &:before {
                background-color: #a1286d;
            }
        }

        &.music__wave {
            &:before {
                background-image: url(/Content/img/card-waves/wave-card-music.svg);
            }
        }

        &.art__wave {
            &:before {
                background-image: url(/Content/img/card-waves/wave-card-art.svg);
            }
        }

        &.literature__wave {
            &:before {
                background-image: url(/Content/img/card-waves/wave-card-literature.svg);
            }
        }

        &.media__wave {
            &:before {
                background-image: url(/Content/img/card-waves/wave-card-media.svg);
            }
        }

        &.stage__wave {
            &:before {
                background-image: url(/Content/img/card-waves/wave-card-stage.svg);
            }
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: -18px;
            width: 100%;
            left: 0;
            height: 20px;
            background-size: cover;
            background-position: top;
            background-repeat: no-repeat;
        }
    }

    .button-container {
        .subsequent-cards:not(.btn-visible) & {
            display: none !important;
        }
    }

    .card ul {
        list-style: none;
        padding-left: 0;

        i {
            color: $green;
            margin-right: 10px;
        }

        @media all and (-ms-high-contrast: none) {
            min-height: 250px;
        }
    }

    .card ul li {
        line-height: 1.5;
        margin-bottom: 10px;
    }
</style>
